import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.QBooksAccountLineItemsSection.TaxCodeCell', {
    warning: '{contactDisplayName} bills had multiple tax rates in the past. Check suggested tax rate.',
});
